import React, { useState } from "react";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useTranslation } from 'react-i18next';

interface PDFViewerProps {
  pdfUrl: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdfUrl }) => {
  const [error, setError] = useState<string>('');
  const { t } = useTranslation();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // Construct worker URL - use public folder first, fallback to CDN
  const workerUrl = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

  // Sunken surface behind the pages: the PDF sheets are the paper, so the tray
  // they sit in has to recede rather than be another white block.
  return (
    <div className="w-full h-full bg-surface-sunken overflow-hidden flex flex-col">
      {error && (
        <div className="flex-shrink-0 bg-warning-50 dark:bg-warning-900 border-b border-warning-200 dark:border-warning-700 p-4 text-sm text-warning-800 dark:text-warning-200">
          {error}
        </div>
      )}
      <div className="flex-1 w-full overflow-auto">
        <Worker workerUrl={workerUrl}>
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance]}
            defaultScale={SpecialZoomLevel.PageWidth}
            onDocumentLoad={() => {}}
            renderError={() => (
              <div className="p-4 text-center text-danger-600 dark:text-danger-400">
                {t('Failed to render PDF. The file may be corrupted or unsupported.')}
              </div>
            )}
          />
        </Worker>
      </div>
    </div>
  );
};

export default PDFViewer;
